/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export * from './header.service';
export * from './footer.service';
export * from './featureSection.service';
export * from './staticPage.service';
export * from './formatPolicyDetail.service';
export * from './formatTimelineDetail.service';
export * from './blockchainTransactionProof.service';
export * from './getTransactionList.service';
export * from './loading-content.plugin';
export * from './error-content.plugin';
